/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SendContactsRequestPayloadDtoJson } from './sendContactsRequestPayloadDtoJson';


export interface GetStatisticsByContactsListResponseEntries { 
    id?: string;
    name?: string;
    datePublished?: string;
    payload?: SendContactsRequestPayloadDtoJson;
    discountRate?: number;
    discountText?: string;
    discountAbsolute?: number;
    billTotal?: number;
    discountDate?: string;
}

